import { render, staticRenderFns } from "./CustomerServiceComponent.vue?vue&type=template&id=ac7b814c&scoped=true&"
import script from "./CustomerServiceComponent.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceComponent.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceComponent.vue?vue&type=style&index=0&id=ac7b814c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7b814c",
  null
  
)

export default component.exports